(function () {
  "use strict";

  var page = document.querySelector("[data-coll-page]");
  if (!page) return;

  var hero = page.querySelector("[data-coll-hero]");
  var staff = page.querySelector("[data-coll-hero-staff]");
  if (!hero || !staff) return;

  var pinKey = "artfolio-promote-pin";
  var staffUiKey = "artfolio-staff-ui";
  var endpoint = (window.theme && window.theme.promoteEndpoint) || "/apps/artfolio/promote";
  var rolls = {};
  var selected = {
    handle: page.getAttribute("data-hero-product") || "",
    title: page.getAttribute("data-hero-product-title") || "",
    url: page.getAttribute("data-hero-product-url") || "",
    vendor: "",
    orientation: "",
    genre: "",
    collections: [{ title: page.getAttribute("data-coll-title") || "" }]
  };
  var draft = {
    url: page.getAttribute("data-hero-draft") || "",
    usedFramed: true
  };
  var picking = false;
  var pickedThisPass = false;
  var previewFresh = false;
  var busy = false;
  var previewCopy = "";

  var toggleBtn = staff.querySelector("[data-coll-hero-toggle]");
  var bodyEl = staff.querySelector("[data-coll-hero-body]");
  var summaryEl = staff.querySelector("[data-coll-hero-summary]");
  var pickedEl = staff.querySelector("[data-coll-hero-picked]");
  var pickBtn = staff.querySelector("[data-coll-hero-pick]");
  var pickDoneBtn = staff.querySelector("[data-coll-hero-pick-done]");
  var roomEl = staff.querySelector("[data-coll-hero-room]");
  var generateBtn = staff.querySelector("[data-coll-hero-generate]");
  var liveBtn = staff.querySelector("[data-coll-hero-live]");
  var revertBtn = staff.querySelector("[data-coll-hero-revert]");
  var retryBtn = staff.querySelector("[data-coll-hero-retry]");
  var discardBtn = staff.querySelector("[data-coll-hero-discard]");
  var progressEl = staff.querySelector("[data-coll-hero-progress]");
  var statusEl = staff.querySelector("[data-coll-hero-status]");
  var pinWrap = staff.querySelector("[data-coll-hero-pin]");
  var pinInput = staff.querySelector("[data-coll-hero-pin-input]");
  var frameEl = staff.querySelector("[data-coll-hero-frame]");
  var frameImg = staff.querySelector("[data-coll-hero-frame-img]");
  var frameEmpty = staff.querySelector("[data-coll-hero-frame-empty]");
  var frameRegen = staff.querySelector("[data-coll-hero-frame-regen]");
  var mediaEl = hero.querySelector("[data-coll-hero-media]");
  var copyEl = hero.querySelector("[data-coll-hero-copy]");
  var topEl = page.querySelector("[data-coll-top]");
  var busyBtns = [pickBtn, pickDoneBtn, generateBtn, liveBtn, revertBtn, retryBtn, discardBtn];

  function hasStaffQuery() {
    try { return /(?:\?|&)staff=1(?:&|$)/.test(location.search || ""); } catch (err) { return false; }
  }
  function hasStoredStaff() {
    try {
      return !!(localStorage.getItem(pinKey) || sessionStorage.getItem(pinKey) || localStorage.getItem(staffUiKey) === "1");
    } catch (err) { return false; }
  }
  function hasAdminChrome() {
    var html = document.documentElement;
    if (html.classList.contains("has-shopify-admin-chrome") || html.classList.contains("shopify-design-mode")) return true;
    try {
      if (window.Shopify && (Shopify.designMode || Shopify.visualPreviewMode)) return true;
    } catch (err) {}
    return !!(
      document.getElementById("PBarNextFrameWrapper") ||
      document.getElementById("PBarNextFrame") ||
      document.getElementById("admin-bar-iframe") ||
      document.getElementById("PreviewBarContainer") ||
      document.querySelector("iframe[id*='admin-bar'], iframe[id*='preview-bar'], [id*='PBarNext'], .shopify-preview-bar, #shopify-preview-bar")
    );
  }
  function detectStaffSession() {
    var themeCfg = window.theme || {};
    if (themeCfg.isStaff || hasStaffQuery() || hasStoredStaff() || hasAdminChrome()) return true;
    try {
      var ref = String(document.referrer || "");
      if (/admin\.shopify\.com/i.test(ref) || /\/admin(\/|$|\?)/i.test(ref)) return true;
    } catch (err) {}
    try {
      if (/(?:preview_theme_id|preview_token)/.test(location.search || "")) return true;
    } catch (err) {}
    return false;
  }
  function rememberStaffUi() {
    try { localStorage.setItem(staffUiKey, "1"); } catch (err) {}
  }
  function readPin() {
    try { return localStorage.getItem(pinKey) || sessionStorage.getItem(pinKey) || ""; } catch (err) { return ""; }
  }
  function writePin(value) {
    try {
      localStorage.setItem(pinKey, value);
      sessionStorage.setItem(pinKey, value);
    } catch (err) {}
  }
  function currentPin() {
    var typed = pinInput && pinInput.value ? String(pinInput.value).trim() : "";
    return typed || readPin();
  }
  function requirePin(actionLabel) {
    var pin = currentPin();
    if (pin) return pin;
    if (pinWrap) pinWrap.hidden = false;
    if (pinInput) pinInput.focus();
    setStatus("Enter the staff PIN to " + (actionLabel || "continue") + ".", true);
    return "";
  }
  function isLive() {
    return page.getAttribute("data-hero-live") === "true";
  }
  function collectionTitle() {
    return page.getAttribute("data-coll-title") || "";
  }
  function collectionHandle() {
    return page.getAttribute("data-coll-handle") || "";
  }
  function setStatus(message, isError) {
    if (!statusEl) return;
    statusEl.textContent = message || "";
    if (isError) statusEl.setAttribute("data-error", "");
    else statusEl.removeAttribute("data-error");
  }
  function setProgress(message, isError) {
    if (!progressEl) return;
    if (!message) {
      progressEl.hidden = true;
      progressEl.textContent = "";
      progressEl.removeAttribute("data-error");
      return;
    }
    progressEl.hidden = false;
    progressEl.textContent = message;
    if (isError) progressEl.setAttribute("data-error", "");
    else progressEl.removeAttribute("data-error");
  }
  function setBusy(on) {
    busy = !!on;
    busyBtns.forEach(function (btn) {
      if (btn) btn.disabled = !!on;
    });
    if (roomEl) roomEl.disabled = !!on;
    if (generateBtn) generateBtn.classList.toggle("is-generating", !!on);
  }
  function setOpen(open) {
    staff.classList.toggle("is-open", !!open);
    if (toggleBtn) toggleBtn.setAttribute("aria-expanded", open ? "true" : "false");
    if (bodyEl) bodyEl.hidden = !open;
  }
  function heroErrors(code) {
    var map = {
      unauthorized: "PIN not accepted. Try again.",
      missing_openai_key: "OpenAI isn’t configured on Promote yet.",
      openai_billing: "OpenAI billing or quota blocked this image.",
      openai_unverified: "GPT Image needs organisation verification in the OpenAI dashboard.",
      openai_rejected: "OpenAI rejected that scene. Try another room.",
      openai_failed: "OpenAI could not generate that scene. Try again.",
      image_fetch_failed: "Couldn’t read the framed reference. Try again.",
      missing_image: "That work needs a framed second photo first. Generate the shopping-feed image on the product page, then come back.",
      missing_fields: "Pick a work first.",
      product_not_found: "Couldn’t load that work.",
      collection_not_found: "Couldn’t load this collection.",
      upload_failed: "Generated, but couldn’t store the image. Try again.",
      file_failed: "Couldn’t save the image into Shopify Files. The preview URL is kept.",
      not_found: "Promote doesn’t know that action yet. Redeploy the function."
    };
    return map[code] || code || "Couldn’t do that.";
  }
  function postPromote(pin, body) {
    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Promote-Pin": pin
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (payload) {
        return { ok: res.ok && payload && payload.ok, status: res.status, body: payload || {} };
      }).catch(function () {
        return { ok: false, status: res.status, body: {} };
      });
    });
  }
  function pollJob(pin, jobId, attempt, pendingCopy) {
    if (attempt > 90) return Promise.reject(new Error("This is taking too long. Check before trying again."));
    return new Promise(function (resolve) {
      window.setTimeout(resolve, attempt ? 1200 : 400);
    }).then(function () {
      return postPromote(pin, { op: "job", jobId: jobId, pin: pin });
    }).then(function (result) {
      var body = result.body || {};
      if (body.pending || body.status === "queued" || body.status === "running") {
        setStatus(pendingCopy || "Still working…", false);
        setProgress(pendingCopy || "Still working…");
        return pollJob(pin, jobId, attempt + 1, pendingCopy);
      }
      if (result.status === 401 || body.error === "unauthorized") {
        var err = new Error("unauthorized");
        err.code = "unauthorized";
        throw err;
      }
      if (body.status === "error" || body.ok === false) {
        var fail = new Error(body.error || "openai_failed");
        fail.code = body.error || "openai_failed";
        throw fail;
      }
      return result;
    });
  }
  function handleAuth(result) {
    if (result.status === 401 || (result.body && result.body.error === "unauthorized")) {
      if (pinWrap) pinWrap.hidden = false;
      if (pinInput) {
        pinInput.value = "";
        pinInput.focus();
      }
      setStatus("PIN not accepted. Try again.", true);
      return true;
    }
    return false;
  }
  function refreshSummary() {
    var live = isLive();
    var label = live ? "Hero is live" : "Text header — hero off";
    if (selected.handle) label += " · " + (selected.title || selected.handle);
    if (summaryEl) summaryEl.textContent = label;
    if (pickedEl) {
      pickedEl.textContent = selected.handle
        ? ("Selected: " + (selected.title || selected.handle))
        : "No work selected.";
    }
    if (liveBtn) liveBtn.hidden = !previewFresh;
    if (revertBtn) revertBtn.hidden = !live;
    if (retryBtn) retryBtn.hidden = !(selected.handle && (previewFresh || draft.url));
    if (discardBtn) discardBtn.hidden = !previewFresh;
  }
  function showSecondImage(url, title, handle) {
    if (!frameEl) return;
    if (!handle) {
      frameEl.hidden = true;
      return;
    }
    frameEl.hidden = false;
    if (frameImg) {
      if (url) {
        frameImg.hidden = false;
        frameImg.src = url;
        frameImg.alt = (title || "Framed print") + ", the 2nd image used for the scene";
      } else {
        frameImg.hidden = true;
        frameImg.removeAttribute("src");
        frameImg.alt = "";
      }
    }
    if (frameEmpty) frameEmpty.hidden = !!url;
    if (frameRegen) frameRegen.href = "/products/" + encodeURIComponent(handle) + "?staff=1";
  }
  function rememberSecondImage(json, handle) {
    var images = json && json.images || [];
    var url = images.length > 1 ? images[1] : "";
    selected.image = url;
    if (json) {
      selected.title = json.title || selected.title;
      selected.vendor = json.vendor || selected.vendor;
      selected.genre = json.type || selected.genre;
      selected.tags = json.tags || [];
    }
    showSecondImage(url, selected.title, handle || selected.handle);
    refreshSummary();
  }
  function fillRooms() {
    if (!roomEl) return;
    var current = page.getAttribute("data-hero-room") || page.getAttribute("data-hero-room-default") || "auto";
    if (window.ArtfolioScenes && typeof window.ArtfolioScenes.fillSelect === "function") {
      window.ArtfolioScenes.fillSelect(roomEl);
      if (roomEl.querySelector('option[value="' + current + '"]')) roomEl.value = current;
    }
  }
  function setPicking(on) {
    picking = !!on;
    if (!picking) pickedThisPass = false;
    page.classList.toggle("is-hero-picking", picking);
    if (pickBtn) pickBtn.hidden = picking;
    if (pickDoneBtn) pickDoneBtn.hidden = !(picking && pickedThisPass);
    setStatus(picking ? "Click a work in the grid. Done selecting appears once one is chosen. Escape cancels." : "", false);
  }
  function ensurePreviewCopy() {
    if (!copyEl || copyEl.hasAttribute("data-filled")) return;
    if (topEl) {
      copyEl.innerHTML = topEl.innerHTML;
      copyEl.setAttribute("data-filled", "1");
      previewCopy = copyEl.innerHTML;
    }
  }
  function showPreview(url, alt) {
    if (!url || !mediaEl) return;
    var img = mediaEl.querySelector("img") || document.createElement("img");
    img.className = "coll-hero__img";
    img.alt = alt || "";
    if (!img.hasAttribute("data-hero-src")) {
      img.setAttribute("data-hero-src", img.getAttribute("src") || page.getAttribute("data-hero-image") || "");
      img.setAttribute("data-hero-srcset", img.getAttribute("srcset") || "");
    }
    img.removeAttribute("srcset");
    img.removeAttribute("sizes");
    img.src = url;
    if (!img.parentNode) mediaEl.appendChild(img);
    hero.classList.add("has-preview");
    hero.hidden = false;
    hero.removeAttribute("hidden");
    page.classList.add("is-hero-preview");
    ensurePreviewCopy();
    if (copyEl) {
      copyEl.hidden = false;
      copyEl.removeAttribute("hidden");
    }
  }
  function restoreHeroImage() {
    var img = mediaEl && mediaEl.querySelector("img");
    if (!img) return;
    var original = img.getAttribute("data-hero-src") || page.getAttribute("data-hero-image") || "";
    var srcset = img.getAttribute("data-hero-srcset") || "";
    if (original) img.src = original;
    if (srcset) img.setAttribute("srcset", srcset);
    img.removeAttribute("data-hero-src");
    img.removeAttribute("data-hero-srcset");
  }
  function clearPreview() {
    previewFresh = false;
    draft.url = page.getAttribute("data-hero-draft") || "";
    hero.classList.remove("has-preview");
    page.classList.remove("is-hero-preview");
    if (isLive()) restoreHeroImage();
    else {
      if (copyEl) copyEl.hidden = true;
      var img = mediaEl && mediaEl.querySelector("img");
      if (img && !page.getAttribute("data-hero-image")) img.remove();
    }
    refreshSummary();
  }
  function productFromCard(card) {
    var link = card.querySelector("[data-studio-handle]") || card.querySelector("a.card") || card.querySelector("a.card-media-link") || card.querySelector("a[href*='/products/']");
    var handle = (
      card.getAttribute("data-work-handle") ||
      (link && link.getAttribute("data-studio-handle")) ||
      ((link && link.getAttribute("href") || "").split("/products/")[1] || "")
    ).split("?")[0];
    handle = String(handle || "").replace(/\/$/, "").trim();
    return {
      handle: handle,
      title: card.getAttribute("data-work-title") || (card.querySelector(".t") && card.querySelector(".t").textContent) || handle,
      url: link ? link.getAttribute("href") : ("/products/" + handle),
      vendor: card.getAttribute("data-work-vendor") || (card.querySelector(".ar") && card.querySelector(".ar").textContent) || "",
      orientation: "",
      genre: "",
      collections: [{ title: collectionTitle() }]
    };
  }
  function markPicked() {
    page.querySelectorAll(".mcard.is-hero-picked").forEach(function (node) {
      node.classList.remove("is-hero-picked");
    });
    if (!selected.handle) return;
    page.querySelectorAll(".mcard").forEach(function (card) {
      var info = productFromCard(card);
      if (info.handle === selected.handle) card.classList.add("is-hero-picked");
    });
  }
  function loadProductJson(handle) {
    return fetch("/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" }).then(function (res) {
      if (!res.ok) return null;
      return res.json();
    }).catch(function () { return null; });
  }
  function sceneProduct() {
    return {
      title: selected.title,
      vendor: selected.vendor,
      handle: selected.handle,
      orientation: selected.orientation,
      genre: selected.genre,
      collections: selected.collections,
      colours: selected.colours || [],
      moods: selected.moods || [],
      blurb: selected.blurb || ""
    };
  }

  if (!detectStaffSession()) return;
  rememberStaffUi();
  hero.hidden = false;
  hero.removeAttribute("hidden");
  staff.hidden = false;
  staff.removeAttribute("hidden");
  fillRooms();
  refreshSummary();
  markPicked();
  if (selected.handle) {
    loadProductJson(selected.handle).then(function (json) {
      if (json) rememberSecondImage(json, selected.handle);
      else showSecondImage("", selected.title, selected.handle);
    });
  }
  if (draft.url && !isLive()) showPreview(draft.url, page.getAttribute("data-hero-alt") || "");

  if (toggleBtn) {
    toggleBtn.addEventListener("click", function () {
      setOpen(!!(bodyEl && bodyEl.hidden));
    });
  }
  if (pickBtn) {
    pickBtn.addEventListener("click", function () {
      setPicking(true);
      setOpen(true);
    });
  }
  if (pickDoneBtn) {
    pickDoneBtn.addEventListener("click", function () {
      setPicking(false);
    });
  }
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && picking) {
      setPicking(false);
    }
  });
  page.addEventListener("click", function (event) {
    if (!picking) return;
    var card = event.target && event.target.closest && event.target.closest(".mcard");
    if (!card) return;
    event.preventDefault();
    event.stopPropagation();
    var info = productFromCard(card);
    if (!info.handle) return;
    selected = info;
    pickedThisPass = true;
    if (pickDoneBtn) pickDoneBtn.hidden = false;
    loadProductJson(info.handle).then(function (json) {
      if (!json) {
        showSecondImage("", selected.title, info.handle);
        return;
      }
      rememberSecondImage(json, info.handle);
    });
    markPicked();
    refreshSummary();
    setStatus("Selected " + (selected.title || selected.handle) + ". The 2nd image is on the right. Generate when you’re ready.", false);
  }, true);

  function generate() {
    if (busy) return;
    var pin = requirePin("generate a collection hero");
    if (!pin) return;
    if (!selected.handle) {
      setStatus("Pick a work from the grid first.", true);
      setPicking(true);
      return;
    }
    if (!window.ArtfolioScenes || typeof window.ArtfolioScenes.bannerPrompt !== "function") {
      setStatus("Scene helper failed to load. Refresh and try again.", true);
      return;
    }
    var roomId = roomEl && roomEl.value ? roomEl.value : "auto";
    var rollKey = collectionHandle() + ":" + selected.handle + ":" + roomId;
    rolls[rollKey] = (rolls[rollKey] || 0) + 1;
    var planned;
    try {
      planned = window.ArtfolioScenes.bannerPrompt(sceneProduct(), roomId, collectionTitle(), rolls[rollKey]);
    } catch (error) {
      setStatus("Couldn’t build that room prompt.", true);
      return;
    }
    setBusy(true);
    setProgress("Painting the collection hero…");
    setStatus("Painting a wide room around the framed print…", false);
    postPromote(pin, {
      op: "generate_collection_hero",
      pin: pin,
      handle: selected.handle,
      collectionHandle: collectionHandle(),
      collectionTitle: collectionTitle(),
      room: planned.scene.roomId || roomId,
      prompt: planned.prompt
    }).then(function (result) {
      if (handleAuth(result)) return null;
      writePin(pin);
      if (pinWrap) pinWrap.hidden = true;
      if (result.body && result.body.pending && result.body.jobId) {
        setStatus("Painting a wide wall with the print on the right…", false);
        setProgress("Painting a wide wall with the print on the right…");
        return pollJob(pin, result.body.jobId, 0, "Painting a wide wall with the print on the right…");
      }
      if (!result.ok) throw new Error((result.body && result.body.error) || "openai_failed");
      return result;
    }).then(function (result) {
      if (!result) {
        setProgress("");
        return;
      }
      var body = result.body || {};
      if (!body.url) throw new Error("openai_failed");
      draft = {
        url: body.url,
        usedFramed: body.usedFramed !== false,
        room: body.room || roomId,
        alt: body.alt || ""
      };
      previewFresh = true;
      showPreview(draft.url, draft.alt);
      refreshSummary();
      setProgress("");
      setStatus("Preview ready. Check the left wall is quiet enough for the title, then Save preview.", false);
    }).catch(function (error) {
      var code = (error && (error.code || error.message)) || "openai_failed";
      var message = heroErrors(code);
      setStatus(message, true);
      setProgress(message, true);
    }).finally(function () {
      setBusy(false);
    });
  }

  if (generateBtn) generateBtn.addEventListener("click", generate);
  if (retryBtn) retryBtn.addEventListener("click", generate);
  if (discardBtn) {
    discardBtn.addEventListener("click", function () {
      clearPreview();
      setStatus("Discarded. The public header is unchanged.", false);
    });
  }
  if (liveBtn) {
    liveBtn.addEventListener("click", function () {
      if (busy) return;
      if (!draft.url) {
        setStatus("Generate a hero first.", true);
        return;
      }
      var pin = requirePin("make this hero live");
      if (!pin) return;
      setBusy(true);
      setStatus("Saving the hero to this collection…", false);
      var urlReady = draft.url.indexOf("data:") === 0
        ? postPromote(pin, {
            op: "upload",
            pin: pin,
            handle: selected.handle,
            image: draft.url,
            scratch: true
          }).then(function (uploaded) {
            if (handleAuth(uploaded)) return "";
            if (!uploaded.ok || !uploaded.body || !uploaded.body.url) throw new Error("upload_failed");
            return uploaded.body.url;
          })
        : Promise.resolve(draft.url);
      urlReady.then(function (imageUrl) {
        if (!imageUrl) return;
        draft.url = imageUrl;
        return postPromote(pin, {
          op: "save_collection_hero",
          pin: pin,
          collectionHandle: collectionHandle(),
          handle: selected.handle,
          url: imageUrl,
          room: (roomEl && roomEl.value) || draft.room || "",
          alt: draft.alt || "",
          live: true
        });
      }).then(function (result) {
        if (!result) return;
        if (handleAuth(result)) return;
        if (!result.ok) throw new Error((result.body && result.body.error) || "upload_failed");
        writePin(pin);
        page.setAttribute("data-hero-live", "true");
        hero.classList.add("is-live");
        setStatus("Live. Reloading so shoppers get the CDN image…", false);
        window.setTimeout(function () { window.location.reload(); }, 400);
      }).catch(function (error) {
        setStatus(heroErrors((error && (error.code || error.message)) || "upload_failed"), true);
      }).finally(function () {
        setBusy(false);
      });
    });
  }
  if (revertBtn) {
    revertBtn.addEventListener("click", function () {
      if (busy) return;
      var pin = requirePin("turn the hero off");
      if (!pin) return;
      setBusy(true);
      setStatus("Reverting to the text header…", false);
      postPromote(pin, {
        op: "set_collection_hero_live",
        pin: pin,
        collectionHandle: collectionHandle(),
        live: false
      }).then(function (result) {
        if (handleAuth(result)) return;
        if (!result.ok) throw new Error((result.body && result.body.error) || "upload_failed");
        writePin(pin);
        setStatus("Text header restored. Reloading…", false);
        window.setTimeout(function () { window.location.reload(); }, 400);
      }).catch(function (error) {
        setStatus(heroErrors((error && (error.code || error.message)) || ""), true);
      }).finally(function () {
        setBusy(false);
      });
    });
  }
})();
